import { useColorModeValue } from '@chakra-ui/react';

export const useColorModeVariables = () => {
  const textColor = useColorModeValue('navy.700', 'white');
  const brandStars = useColorModeValue('secondary', 'brand.400');
  const tabletextColor = useColorModeValue('primary', 'white');
  return { textColor, brandStars, tabletextColor };
};
